import React, { useMemo, useState } from "react";
import { Formik, Form, Field, ErrorMessage } from "formik";
import { useContext } from "react";
import { expertContext } from "../../../../context/expertcontext";
import Steps from "./Steps";
import { FaTrash, FaPen } from "react-icons/fa";
import { desSchema } from "../../../../validation/validation";
import Num2persian from "num2persian";
import { toast } from "react-hot-toast";
const Description = ({ arry,description }) => {
  const { setTab, tab, setAttributes, attributes , setTotal1 } = useContext(expertContext);
  const [aryy, setArry] = useState(attributes);
  const [attr, setAttr] = useState({
    title: "",
    type: "Property",
    QTY: "",
    unit: "meter",
    phi: "",
    price: 0,
  });
  const nextStep = (values) => {
    if (tab < 6) {
      setTab(tab + 1);
    }
  };
  const previousStep = (values) => {
    if (tab > 1) {
      setTab(tab - 1);
    }
  };

  const addNewAtr = (value, resetForm) => {
    if(value.title && value.QTY && value.phi){
      let copy = [...aryy];
      let copy2 = {...value}
      copy2.price = Math.round(value.phi * value.QTY)
      // console.log(copy2)
    copy.push(copy2);
    setArry(copy);
    // console.log(copy);
    resetForm();
    setAttr({
      title: "",
      type: "Property",
      QTY: "",
      unit: "meter",
      phi: "",
      price: 0,
    })
    }else{
      toast.error("لطفا مقادیر را به طور کامل وارد کنید")
    }
  };

  const deleteItem = (i, index) => {
    let copy = [...aryy];
    copy.splice(index, 1);
    setArry(copy);
  };

  const total = useMemo(()=>{
    let sum = 0
    aryy.map((i)=> {
      let price = i.phi*i.QTY
      sum+= price
    })
    setTotal1(sum)
    return sum
  } , [aryy])

  return (
    <div>
      <Formik
        initialValues={{
          attributes: {
            ...attr,
          },
        }}
        validationSchema={''}
        onSubmit={(values, { resetForm }) => {
          console.log(aryy);
          nextStep();
          setAttributes(aryy);
        }}
        enableReinitialize={true}
      >
        {({
          isSubmitting,
          errors,
          setFieldValue,
          handleChange,
          values,
          resetForm,
        }) => (
          <Form>
            <div className="soratkarshenasi-form">
              <div className="row align-items-start">
                <div className="mb-3 col-sm-4 ">
                  <label
                    className="mb-1 ms-2 d-flex label-form karshenasi-label"
                    htmlFor="name"
                  >
                    شرح :{" "}
                  </label>
                  <div className="d-flex">
                    <Field
                      type="text"
                      className="w-75 karshenasi-input px-2"
                      name={`attributes.title`}
                    />
                    <Field
                      as="select"
                      className="w-25 karshenasi-input px-2"
                      name={`attributes.title`}
                      style={{
                        backgroundColor: "#6BBA81",
                        border: "none",
                        marginRight: "-25px",
                      }}
                    >
                      <option>بیشتر</option>
                      {description.map((s, index) => (
                        <option key={index} value={s.name}>
                          {s.name}
                        </option>
                      ))}
                    </Field>
                  </div>
                  <ErrorMessage
                    name={`attributes.title`}
                    render={(msg) => <div className="text-danger">{msg}</div>}
                  />
                </div>
                <div className="mb-3 col-6 col-sm-3 ">
                  <label
                    className="mb-1 ms-2 d-flex label-form karshenasi-label"
                    htmlFor="name"
                  >
                    متراژ
                  </label>
                  <Field
                    className="w-100 karshenasi-input px-2"
                    name={`attributes.QTY`}
                    type="number"
                  />
                  <ErrorMessage
                    name={`attributes.QTY`}
                    render={(msg) => <div className="text-danger">{msg}</div>}
                  />
                </div>
                <div className="mb-3 col-6 col-sm-3 ">
                  <label
                    className="mb-1 ms-2 d-flex label-form karshenasi-label"
                    htmlFor="name"
                  >
                    قیمت
                  </label>
                  <Field
                    className="w-100 karshenasi-input px-2"
                    name={`attributes.phi`}
                    type="number"
                  />
                  <p>{values.attributes.phi && Num2persian(values.attributes.phi)} تومان</p>
                  <ErrorMessage
                    name={`attributes.phi`}
                    render={(msg) => <div className="text-danger">{msg}</div>}
                  />
                </div>
                <div className="mb-3 col-sm-2 ">
                  <label
                    className="mb-3 ms-2 d-flex label-form karshenasi-label"
                    htmlFor="name"
                  >
                    {" "}
                  </label>
                  <button
                    className="btn des-add-btn"
                    style={{
                      width: "200px",
                      backgroundColor: "#6BBA81",
                      color: "#fff",
                      borderRadius: "20px",
                    }}
                    type="button"
                    onClick={() => {
                      addNewAtr(values.attributes, resetForm);
                    }}
                  >
                    افزودن
                  </button>
                </div>
              </div>

              <div className="description-tabel-box px-3">
                <table className="table">
                  <thead className="text-end">
                    <tr>
                      <th scope="col">شرح</th>
                      <th scope="col">متراژ</th>
                      <th scope="col">قیمت(تومان)</th>
                      <th scope="col">قیمت کل</th>
                      <th scope="col"></th>
                    </tr>
                  </thead>
                  <tbody className="text-end">
                    {aryy.map((i, index) => (
                      <tr key={index}>
                        <td>{i.title}</td>
                        <td>{parseFloat(i.QTY).toFixed(2)}</td>
                        <td>{i.phi.toLocaleString()}</td>
                        <td>{(i.phi * i.QTY).toLocaleString()}</td>
                        <td>
                          <div className="d-flex">
                            <button
                              type="button"
                              className="btn"
                              onClick={() => {
                                setAttr(i);
                                deleteItem(i, index);
                              }}
                            >
                              <FaPen />
                            </button>
                            <button
                              type="button"
                              className="btn"
                              onClick={() => {
                                deleteItem(i, index);
                              }}
                            >
                              <FaTrash />
                            </button>
                          </div>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
              <p className="mb-0 text-end">جمع کل: {total.toLocaleString()} تومان</p>
              <p className="text-end">{total && Num2persian(Math.round(total))} تومان</p>
            </div>

            <div>
              <Steps />
              <div className="mb-2 px-2 d-flex justify-content-between">
                <div className=" request-next-btn-box mt-2">
                  <button type="submit" className="btn request-next-btn">
                    بعدی
                  </button>
                </div>
                <div className=" request-Previous-btn-box mt-2">
                  <button
                    className="btn request-Previous-btn "
                    type="button"
                    onClick={() => {
                      previousStep();
                    }}
                  >
                    قبلی
                  </button>
                </div>
              </div>
            </div>
          </Form>
        )}
      </Formik>
    </div>
  );
};

export default Description;
